/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Split_Multiview_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to split multiview group: {error}" |
*
* @param {Split_Multiview_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_failed = /** @type {((inputs: Split_Multiview_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de la division du groupe multivue : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Aufteilen der Multiview-Gruppe: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile suddividere il gruppo multivista: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось разделить группу с несколькими представлениями: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al dividir el grupo multivista: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`拆分多视图组失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`マルチビューグループの分割に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मल्टीव्यू समूह को विभाजित करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao dividir o grupo de visualização múltipla: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to split multiview group: ${i?.error}`)
});